"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../assets/css/font-face.css");

require("../assets/css/font.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Text = function Text(_ref) {
  var h1 = _ref.h1,
      h2 = _ref.h2,
      h3 = _ref.h3,
      h4 = _ref.h4,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["h1", "h2", "h3", "h4", "children"]);

  if (h1) return _react.default.createElement("h1", rest, children);
  if (h2) return _react.default.createElement("h2", rest, children);
  if (h3) return _react.default.createElement("h3", rest, children);
  if (h4) return _react.default.createElement("h4", rest, children);
  return _react.default.createElement("p", rest, children);
};

Text.defaultProps = {
  h1: false,
  h2: false,
  h3: false,
  h4: false
};
Text.propTypes = {
  h1: _propTypes.default.bool,
  h2: _propTypes.default.bool,
  h3: _propTypes.default.bool,
  h4: _propTypes.default.bool,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired
};
var _default = Text;
exports.default = _default;